export const AUTHENTICATED = 'components/password-reset/AUTHENTICATED';

export const authenticated = () => ({
  type: AUTHENTICATED,
});
